var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
import isEmpty from "./isEmpty";
var block = bem("rmd-badge");
/**
 * This component is generally used for displaying notifications with a count
 * relative to another element with the `BadgeContainer` component. However, it
 * can be used by itself to display any subpplementary content if needed.
 */
var Badge = forwardRef(function Badge(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.theme, theme = _c === void 0 ? "default" : _c, _d = _a.children, children = _d === void 0 ? null : _d, _e = _a.disableNullOnZero, disableNullOnZero = _e === void 0 ? false : _e, props = __rest(_a, ["className", "theme", "children", "disableNullOnZero"]);
    if (isEmpty(children, disableNullOnZero)) {
        return null;
    }
    return (React.createElement("span", __assign({}, props, { ref: ref, className: cn(block((_b = {}, _b[theme] = theme !== "clear", _b)), className) }), children));
});
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        Badge.propTypes = {
            id: PropTypes.string.isRequired,
            theme: PropTypes.oneOf(["primary", "secondary", "default", "clear"]),
            className: PropTypes.string,
            children: PropTypes.node,
            disableNullOnZero: PropTypes.bool,
        };
    }
    catch (e) { }
}
export default Badge;
//# sourceMappingURL=Badge.js.map